import './AppLevelAlerts.css';

import { Alert, AlertItem } from '@vmware-react/clarity';
import React, { useEffect, useState } from 'react';

import { AsyncOpState } from 'vrlcm-gui-types';
import { SettingsApi } from 'vrlcm-gui-api';
import { l10n } from '../i18n/i18nUtil';

const storagePercentStrToNumVal = (percent?: string): number | undefined =>
  percent && percent.length > 0 && percent.indexOf('%') !== -1
    ? +percent.substring(0, percent.indexOf('%'))
    : undefined;

const AppLevelAlerts: React.FC = () => {
  const [fetchData, setFetchData] = useState<{
    state: AsyncOpState;
    data?: {
      lowFreeDiskSpace: boolean;
      usedSpace: string;
    };
  }>({
    state: AsyncOpState.NotStarted
  });

  useEffect(() => {
    SettingsApi.getSystemInformation().then(
      res => {
        const storagePercent = storagePercentStrToNumVal(res.storagePercentage);
        setFetchData({
          state: AsyncOpState.Completed,
          data: {
            lowFreeDiskSpace:
              storagePercent !== undefined && storagePercent >= 90,
            usedSpace: res.storagePercentage
          }
        });
      },
      () =>
        setFetchData({
          state: AsyncOpState.Failed
        })
    );
  }, []);

  return (
    <>
      {fetchData.state === AsyncOpState.Completed &&
      fetchData.data &&
      fetchData.data.lowFreeDiskSpace ? (
        <Alert
          type="danger"
          appLevel={true}
          ariaLiveMsg={l10n('components.withAppRoot.lowFreeDiskSpaceText', [
            fetchData.data.usedSpace
          ])}
          items={[
            <AlertItem>
              <span
                dangerouslySetInnerHTML={{
                  __html: l10n('components.withAppRoot.lowFreeDiskSpaceHTML', [
                    fetchData.data.usedSpace
                  ])
                }}
              ></span>
            </AlertItem>
          ]}
        />
      ) : (
        undefined
      )}
    </>
  );
};

export default AppLevelAlerts;
